import { render, staticRenderFns } from "./ComplaintDetailHeaderCard.vue?vue&type=template&id=5e874560&"
import script from "./ComplaintDetailHeaderCard.vue?vue&type=script&lang=js&"
export * from "./ComplaintDetailHeaderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports